import React, { useEffect } from "react";
// import { useMount } from "../hooks/index";
import { WxLoginDialog, SureInfoDialog } from "./dialog/index";

// import globalStore from "./globalStore";
import authStore from "../stores/authStore";
import { ToastManager, 
  // Notify 
} from "../components/index";

const Global = () => {
  const { userInfo, updateAppInfo } = authStore();

  useEffect(() => {
    updateAppInfo("mount", true);
  }, []);

  useEffect(() => {
    if (userInfo.id) {
      // Notify.success({
      //   message: "当前处于登录状态",
      // });
      console.info("userInfo", userInfo);
    }
  }, [userInfo.id]);

  return (
    <div className="good_use-global">
      <WxLoginDialog />
      <SureInfoDialog />
      <ToastManager />
      <p className="is-text-over"></p>
    </div>
  );
};

export default Global;
